import { Plus } from 'lucide-react'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { TableCell, TableRow } from 'src/shared/components/ui/table'
import { Column, Row } from 'src/shared/components/Semantic/all'

export const AddDecorationButton = ({
  onAddDecoration,
  showDiscountColumn = true,
}: {
  onAddDecoration: () => void
  showDiscountColumn?: boolean
}) => {
  const { t } = useLocalization()

  return (
    <TableRow
      className="border-b border-gray-200 hover:bg-gray-50/80 cursor-pointer w-full"
      onClick={onAddDecoration}
    >
      <TableCell className="py-2 px-5 pl-12 text-xs text-gray-700 align-middle group">
        <Row className="gap-3 items-center">
          <div className="w-8 h-8 object-cover rounded-sm border border-gray-200 flex items-center justify-center cursor-pointer shrink-0 group-hover:bg-gray-50 transition-colors">
            <Plus className="w-3.5 h-3.5 text-gray-400 group-hover:text-gray-900" />
          </div>

          <Column className="gap-0.5 min-w-0">
            <p className="text-gray-400 group-hover:text-gray-900">
              {t('Add decoration', 'Lägg till dekoration')}
            </p>
          </Column>
        </Row>
      </TableCell>

      {showDiscountColumn && (
        <TableCell className="py-2 px-5 pl-12 text-xs text-gray-700 align-middle" />
      )}
      <TableCell className="py-2 px-5 pl-12 text-xs text-gray-700 align-middle" />
    </TableRow>
  )
}
